import { PoolerUser } from '../../models/user';
import { EmploymentStatusEnum } from '../../models/employment';
import { Customer } from '../../models/customer';
import { getEmploymentsCriteriaQuery } from './getEmploymentsCriteriaQuery';
import { getEmploymentJoinAndLeaveDateQuery } from './getEmploymentJoinAndLeaveDateQuery';

export function getPossibleEmploymentsQuery(
  currentUser: PoolerUser,
  customersOfPooler: Customer[],
): Record<string, any> | undefined {
  if (!customersOfPooler.length) {
    return;
  }
  const customerQueries = customersOfPooler
    // filter customers that allow the pooler to work in employments
    .filter((customer) => {
      return currentUser.customerInformation?.[customer._id]?.enableEmployments;
    })
    .map((customer) => {
      const customer$AndQuery: Record<string, any>[] = [
        {
          'department.id': {
            $in:
              currentUser.customerInformation?.[customer._id]?.departmentIds ||
              [],
            $nin: currentUser.userPreferenceDepartmentBlacklist || [],
          },
        },
      ];
      const joinAndLeaveDateQuery = getEmploymentJoinAndLeaveDateQuery(
        currentUser,
        customer,
      );
      if (joinAndLeaveDateQuery) {
        customer$AndQuery.push(joinAndLeaveDateQuery);
      }
      return {
        $or: [
          {
            'customer.id': {
              $in: [
                ...customer.pool.employmentsSharedWithCustomerIds,
                customer._id,
              ],
            },
          },
          {
            transfers: {
              $elemMatch: {
                'targetCustomer.id': customer._id,
                transferredAt: { $exists: true },
              },
            },
          },
        ],
        $and: customer$AndQuery,
      };
    });
  return {
    'invitees.userId': { $ne: currentUser._id },
    status: EmploymentStatusEnum.OPEN,
    $or: customerQueries.length ? customerQueries : [{ 'customer.id': '' }], // if no customer is allowed, return empty array (no employments allowed)
    $and: [getEmploymentsCriteriaQuery(currentUser)],
  };
}
